import React from 'react';
import UpgradeCard from '../UpgradeCard';

interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentGuestCount?: number;
  maxFreeGuests?: number;
  currentEvent?: any;
  eventId?: string;
  onUpgrade?: () => void;
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({
  isOpen,
  onClose,
  currentGuestCount = 15,
  maxFreeGuests = 15,
  currentEvent,
  eventId,
  onUpgrade,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900/30 flex items-center justify-center z-50 p-4">
      <div className="max-w-md w-full relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute -top-2 -right-2 z-10 bg-white rounded-full p-2 shadow-lg text-gray-500 hover:text-gray-700 transition-colors"
          aria-label="Close modal"
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Upgrade Card */}
        <UpgradeCard
          title="Upgrade Your Event"
          subtitle={`You've reached the free event limit of ${maxFreeGuests} guests`}
          showCurrentStatus={true}
          currentGuestCount={currentGuestCount}
          maxFreeGuests={maxFreeGuests}
          currentEvent={currentEvent}
          eventId={eventId}
          compact={true}
        />

        {/* Maybe Later Button */}
        <button
          onClick={onClose}
          className="w-full mt-4 px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors bg-white"
        >
          Maybe Later
        </button>
      </div>
    </div>
  );
};

export default UpgradeModal;